module.exports = __webpack_public_path__ + "media/my-account/phone--pink-cf6169c5.svg";